import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinnavimumbai() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Navi Mumbai MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Navi Mumbai MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Corporate Cab Services in Navi Mumbai MIDC, designed to support the transportation needs of industrial units, manufacturing plants, and corporate offices in the region. Our fleet of well-maintained sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily staff commute, plant visits, airport transfers, executive travel, or business meetings, we deliver smooth and hassle-free mobility solutions. With experienced chauffeurs, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a seamless and premium travel experience for companies operating in and around Navi Mumbai MIDC.',

    top: 'Top Places to Visit in Navi Mumbai with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "Bandra Kurla Complex is Mumbai’s premier financial and commercial district, home to multinational corporations, consulates, global banks, Fortune 500 headquarters, and luxury business hotels. The area includes iconic business towers such as Jio World Centre, Naman Chambers, and The Capital. BKC is the top hotspot for corporate meetings, high-profile events, executive travel, and airport transfers—making it one of the busiest destinations for corporate cab services."
    },
    {
      "title": "Lower Parel Corporate Hub",
      "description": "Lower Parel is Mumbai’s most dynamic corporate zone, combining high-rise office towers like One Indiabulls Centre, Peninsula Business Park, and Lodha World Towers. The area is filled with premium coworking spaces, studios, business hotels, and award-winning restaurants. With its mix of creative agencies, finance companies, and MNCs, Lower Parel demands fast, reliable corporate commuting throughout the day."
    },
    {
      "title": "Nariman Point Business District",
      "description": "Nariman Point is one of India’s oldest and most prestigious business districts, housing corporate headquarters, legal firms, government offices, and international consulates. Overlooking the Marine Drive seafront, it contains iconic commercial towers like Air India Building and Maker Chambers. High-density office traffic makes Nariman Point a prime route for corporate cab travel, especially during peak office hours."
    },
    {
      "title": "Andheri MIDC & SEEPZ",
      "description": "Andheri MIDC and SEEPZ SEZ are major industrial and tech zones in Mumbai, home to IT companies, export houses, manufacturing units, and global service providers. With thousands of employees working across multiple shifts, this zone witnesses high demand for employee transportation, shift-based staff travel, and corporate shuttle services throughout the day."
    },
    {
      "title": "Goregaon Nesco Business Park",
      "description": "Nesco IT Park in Goregaon East has become a major commercial destination with modern office towers, convention centers, and large corporate campuses. It hosts companies in IT, finance, BFSI, and media industries. Its proximity to the Western Express Highway and large employee base makes it one of the most active hubs for corporate cab requirements and executive travel."
    },
    {
      "title": "Powai Hiranandani Business District",
      "description": "Powai’s Hiranandani Business Park is a premium corporate environment featuring modern office complexes, luxury residences, and scenic surroundings. It hosts companies like Nomura, CRISIL, Deloitte, and JP Morgan. The area is known for high-end corporate travel, airport pickups, client meeting routes, and executive chauffeur services due to its professional working crowd."
    },
    {
      "title": "Vikhroli Godrej Business District",
      "description": "Vikhroli is home to the massive Godrej Business Park along with multiple commercial towers, IT campuses, and research facilities. Surrounded by greenery and located close to eastern business zones, it is a preferred location for tech firms and innovation centers. The daily movement of employees and corporate visitors creates consistent demand for premium mobility services."
    },
    {
      "title": "Andheri East Corporate Zone",
      "description": "Andheri East is Mumbai’s largest corporate cluster, packed with commercial towers like Solitaire Corporate Park, Ackruti Star, Times Square, and Hubtown Solaris. Its strategic location near Mumbai Airport makes it a hotspot for business travelers, frequent flyers, and client visits. Corporate cab services play a crucial role in daily commutes, airport drops, and inter-office travel."
    },
    {
      "title": "Malad Mindspace IT Park",
      "description": "Mindspace Malad is one of Mumbai’s biggest IT parks, hosting thousands of professionals working in tech, BPO, and corporate services. With companies like Amazon, Accenture, and JP Morgan operating here, the area runs round-the-clock mobility needs including daily office travel, night shift employee transportation, and executive cab services."
    },
    {
      "title": "Thane Ghodbunder Corporate Belt",
      "description": "Ghodbunder Road in Thane has rapidly grown into a major business corridor with IT parks, commercial complexes, and premium office towers. Corporate hubs like G:Corp, Orion Business Park, and TCS Olympus Centre bring huge employee footfall. It is well-connected to Mumbai, Navi Mumbai, and Thane, making it a high-demand route for corporate taxi and staff transportation services."
    }
  ],


"services": [
{
"name": "Navi Mumbai MIDC Employee Cab",
"description": "Navi Mumbai MIDC Employee Cab provides reliable and structured transportation for employees working in Navi Mumbai MIDC. The service features trained drivers, GPS-enabled vehicles, multi-shift support, and optimized routes to ensure safe, comfortable, and punctual daily commuting for industrial and office staff."
},
{
"name": "Corporate Shuttle Navi Mumbai",
"description": "Corporate Shuttle Navi Mumbai delivers organized multi-passenger shuttle services for corporate offices, factories, and IT parks. The service includes GPS-tracked vehicles, trained drivers, structured routing, and timely pickups, ensuring efficient and safe employee transportation across Navi Mumbai."
},
{
"name": "Industrial Cab Navi Mumbai MIDC",
"description": "Industrial Cab Navi Mumbai MIDC offers dedicated transport solutions for factory and industrial employees. The service provides safe, comfortable, and punctual commuting with well-maintained vehicles, trained chauffeurs, GPS-enabled monitoring, and structured multi-shift routes."
},
{
"name": "Staff Pickup Drop Navi Mumbai",
"description": "Staff Pickup Drop Navi Mumbai provides dependable daily pickup and drop services for office and industrial employees. The service emphasizes safety, punctuality, optimized routes, and professional drivers to ensure seamless and stress-free commuting for staff members."
},
{
"name": "Worker Transport Navi Mumbai",
"description": "Worker Transport Navi Mumbai delivers organized transport solutions for industrial and factory staff. The service includes multi-shift support, trained drivers, GPS monitoring, and well-maintained vehicles to ensure safe, timely, and comfortable daily commuting."
},
{
"name": "Best Corporate Cab Navi Mumbai MIDC",
"description": "Best Corporate Cab Navi Mumbai MIDC offers premium-quality corporate transportation for employees, managers, and executives. The service features trained drivers, GPS-enabled vehicles, structured routes, well-maintained sedans and SUVs, and punctual pickups for seamless commuting."
},
{
"name": "Monthly Cab Navi Mumbai",
"description": "Monthly Cab Navi Mumbai provides long-term cab rental solutions for companies requiring consistent employee commuting services. The service includes fixed monthly plans, trained chauffeurs, structured routes, GPS-enabled vehicles, and reliable daily schedules for safe and comfortable transportation."
},
{
"name": "Affordable Office Cab Navi Mumbai",
"description": "Affordable Office Cab Navi Mumbai offers cost-effective transportation solutions for office employees and corporate staff. The service ensures reliable pickups, trained drivers, GPS monitoring, and well-maintained vehicles to provide safe, punctual, and budget-friendly commuting."
},
{
"name": "Company Travel Cab Navi Mumbai MIDC",
"description": "Company Travel Cab Navi Mumbai MIDC delivers dedicated corporate cab services for business travel, client visits, and employee commuting. The service features professional drivers, GPS-enabled vehicles, structured routes, and well-maintained cars to ensure comfortable and timely transportation."
},
{
"name": "Outstation Cab Navi Mumbai",
"description": "Outstation Cab Navi Mumbai provides long-distance travel solutions for corporate employees, executives, and teams. The service includes GPS-enabled vehicles, trained drivers, optimized routes, and comfortable seating to ensure safe, punctual, and hassle-free intercity transportation."
},
{
"name": "Sedan Cab Navi Mumbai MIDC",
"description": "Sedan Cab Navi Mumbai MIDC offers premium sedan vehicles for corporate travel, employee commuting, and executive transport. The service ensures punctual pickups, trained drivers, GPS monitoring, and well-maintained vehicles for a safe and comfortable ride."
},
{
"name": "SUV Cab Navi Mumbai MIDC",
"description": "SUV Cab Navi Mumbai MIDC provides spacious and comfortable SUVs for team travel, industrial staff transport, and corporate commuting. The service features trained chauffeurs, GPS-enabled vehicles, optimized routes, and multi-shift support to ensure reliable and safe transportation."
},
{
"name": "Corporate Fleet Navi Mumbai",
"description": "Corporate Fleet Navi Mumbai delivers fully managed corporate fleet solutions including sedans, SUVs, and staff cabs. The service includes driver management, vehicle maintenance, GPS tracking, and structured routing to ensure seamless and efficient daily commuting for companies."
},
{
"name": "Factory Cab Navi Mumbai",
"description": "Factory Cab Navi Mumbai specializes in large-scale employee transport for industrial units. The service provides multi-passenger vehicles, trained drivers, GPS monitoring, structured shifts, and safe commuting practices for timely and reliable factory staff transport."
},
{
"name": "Business Travel Cabs Navi Mumbai",
"description": "Business Travel Cabs Navi Mumbai offers professional corporate transportation for executives, client visits, and business trips. The service ensures punctual pickups, trained chauffeurs, GPS-enabled vehicles, and optimized routes for efficient and comfortable corporate travel."
}
],

"tableData": [
["Navi Mumbai MIDC Employee Cab", "Corporate Shuttle Navi Mumbai"],
["Industrial Cab Navi Mumbai MIDC", "Staff Pickup Drop Navi Mumbai"],
["Worker Transport Navi Mumbai", "Best Corporate Cab Navi Mumbai MIDC"],
["Monthly Cab Navi Mumbai", "Affordable Office Cab Navi Mumbai"],
["Company Travel Cab Navi Mumbai MIDC", "Outstation Cab Navi Mumbai"],
["Sedan Cab Navi Mumbai MIDC", "SUV Cab Navi Mumbai MIDC"],
["Corporate Fleet Navi Mumbai", "Factory Cab Navi Mumbai"],
["Business Travel Cabs Navi Mumbai", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Navi Mumbai MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Navi Mumbai MIDC, ensuring seamless and efficient transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drops, helping corporate staff reach offices, plants, and business hubs in Navi Mumbai MIDC efficiently."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure corporate commutes."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Navi Mumbai MIDC."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Navi Mumbai MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and employees in Navi Mumbai MIDC.',
  },
  {
    question: 'What types of corporate cab services are available in Navi Mumbai MIDC?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for industrial areas.',
  },
  {
    question: 'Do you support daily commuting for employees in Navi Mumbai MIDC?',
    answer: 'Yes, we provide optimized daily commute solutions with timely pickups and flexible shift scheduling for MIDC employees.',
  },
  {
    question: 'How can companies book corporate cab services in Navi Mumbai MIDC?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Navi Mumbai MIDC?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and terms.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Navi Mumbai MIDC?',
    answer: 'Yes, we handle transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Navi Mumbai MIDC?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Patil',
    feedback: 'Highly reliable corporate cab service for Navi Mumbai MIDC. Punctual, safe, and well-managed transportation.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Rao',
    feedback: 'Excellent service for our employees in Navi Mumbai MIDC. Professional drivers and smooth operations.',
    rating: 5,
  },
];




























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Navi Mumbai MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-navi-mumbai-midc.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services in Navi Mumbai MIDC, including employee transportation, staff pickup & drop, industrial area mobility, factory worker transport, monthly corporate cabs, business travel cabs, shuttle services, and executive chauffeur-driven cars for companies operating in Navi Mumbai MIDC.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-navi-mumbai-midc"
  }
};






  return (
    <div>
      <Helmet>
  <title>Corporate Cab Services in Navi Mumbai MIDC | Employee & Industrial Cabs</title>

  <meta
    name="description"
    content="Premium corporate cab services in Navi Mumbai MIDC including employee transport, staff pickup & drop, industrial area cabs, factory worker travel, business cabs, monthly corporate cabs, shuttle services, and chauffeur-driven executive cars. Reliable service for companies in Navi Mumbai MIDC."
  />

  <meta
    name="keywords"
    content="Navi Mumbai MIDC Employee Cab, Corporate Shuttle Navi Mumbai, Industrial Cab Navi Mumbai MIDC, Staff Pickup Drop Navi Mumbai, Worker Transport Navi Mumbai, Best Corporate Cab Navi Mumbai MIDC, Monthly Cab Navi Mumbai, Affordable Office Cab Navi Mumbai, Company Travel Cab Navi Mumbai MIDC, Outstation Cab Navi Mumbai, Sedan Cab Navi Mumbai MIDC, SUV Cab Navi Mumbai MIDC, Corporate Fleet Navi Mumbai, Factory Cab Navi Mumbai, Business Travel Cabs Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinnavimumbai;